export const iconFontAwesomeDisasterCrisisBiohazard = (
	<i className="fa-solid fa-biohazard"></i>
);
